import { VCol } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    { staticClass: "my-4" },
    _vm._l(_vm.escalas, function (escala) {
      return _c(
        VCol,
        { key: escala.descricao },
        [
          [
            _c(
              "div",
              { staticClass: "d-flex flex-column", attrs: { align: "center" } },
              [
                _c(VRating, {
                  attrs: {
                    length: 5,
                    readonly: "",
                    "background-color": "grey",
                    color: "secondary lighten-3",
                    size: "20",
                  },
                  model: {
                    value: escala.rating,
                    callback: function ($$v) {
                      _vm.$set(escala, "rating", $$v)
                    },
                    expression: "escala.rating",
                  },
                }),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(escala.descricao)),
                ]),
              ],
              1
            ),
          ],
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }